import { Typography } from "@mui/material";
import { PhaseListForms } from "./types";
import React from "react";
import { formatFormCompletion } from "./formCompletion";

const FormCompletionStatus = ({
  selectedForm,
}: {
  selectedForm: PhaseListForms | null;
}) => {
  if (!selectedForm) return null;

  const { display, label } = formatFormCompletion(
    selectedForm.status,
    selectedForm.completedAt,
    "full"
  );

  if (display) {
    return (
      <Typography variant="body2" color="text.secondary">
        {display}
      </Typography>
    );
  }

  return (
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
  );
};

export default React.memo(FormCompletionStatus);
